import { render, staticRenderFns } from "./MassEditMessageVariablesSettings.vue?vue&type=template&id=e6bb11c2&scoped=true"
import script from "./MassEditMessageVariablesSettings.vue?vue&type=script&lang=ts"
export * from "./MassEditMessageVariablesSettings.vue?vue&type=script&lang=ts"
import style0 from "./MassEditMessageVariablesSettings.vue?vue&type=style&index=0&id=e6bb11c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bb11c2",
  null
  
)

export default component.exports